import { css } from "@emotion/react";
import { whiteBaseButtonStyle } from "pages/AccountSettlementHistoryOrderId/styles/commonStyles";

export const receiptButtonStyle = css`
  ${whiteBaseButtonStyle};
  width: 132px;
`;
